import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ISidebar, SidebarService } from '../sidebar/sidebar.service';
import { SessionService } from '../../../shared/session.service';
import { CompanyUserService } from '@app/@services/company-user.service';

@Component({
  selector: 'app-topNavUserProfile',
  templateUrl: './topnavUserProfile.component.html',
})
export class topnavUserProfile implements OnInit, OnDestroy {
  adminRoot = environment.adminRoot;
  sidebar: ISidebar;
  subscription: Subscription;
  selectedCompany: any;
  currentLanguage: string;
  isSingleLang;
  searchKey = '';
  userCompanies: any[] = [];
  filteredUserCompanies: any[] = [];
  bsModalRef: BsModalRef;
  @Input() imageURL:  string = '';

  constructor(
    private sidebarService: SidebarService,
    private companyUserService: CompanyUserService,
    private sessionService: SessionService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {

    this.subscription = this.sidebarService.getSidebar().subscribe(
      (res) => {
        this.sidebar = res;
      },
      (err) => {
        console.error(`An error occurred: ${err.message}`);
      }
    );

    await this.getUserCompanies();
  }

  async getUserCompanies() {
    const result = await this.companyUserService.getUserCompanies();
    this.userCompanies = result?.Data;
    this.filteredUserCompanies = result?.Data;
    if (this.userCompanies) {
      const companyId = localStorage.getItem('companyId');
      if (companyId) 
      {
        let companies = this.userCompanies.filter((o) => o.companyId === companyId);
        if (companies?.length > 0) {
          this.selectedCompany = companies[0];
          this.filteredUserCompanies = this.userCompanies.filter(f=> f.companyId != this.selectedCompany.companyId);
          localStorage.setItem('companyId', companyId);
          return;
        }
      }
      
      this.selectedCompany = this.userCompanies[0];
      this.filteredUserCompanies = this.userCompanies.filter(f=> f.companyId != this.selectedCompany.companyId);
      localStorage.setItem('companyId', this.selectedCompany.companyId);
    }
  }

  activateCompany(item: any) {
    this.selectedCompany = item;
    this.filteredUserCompanies = this.userCompanies.filter(f=> f.companyId != item.companyId);
    localStorage.setItem('companyId', item.companyId);
    window.location.reload();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  menuButtonClick = (
    e: { stopPropagation: () => void },
    menuClickCount: number,
    containerClassnames: string
  ) => {
    if (e) {
      e.stopPropagation();
    }

    setTimeout(() => {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('resize', false, false);
      window.dispatchEvent(event);
    }, 350);

    this.sidebarService.setContainerClassnames(
      ++menuClickCount,
      containerClassnames,
      this.sidebar.selectedMenuHasSubItems
    );
  };

  mobileMenuButtonClick = (
    event: { stopPropagation: () => void },
    containerClassnames: string
  ) => {
    if (event) {
      event.stopPropagation();
    }
    this.sidebarService.clickOnMobileMenu(containerClassnames);
  };

  onSignOut(): void {
    this.sessionService.logoutSession();
  }

  topNav(menu: string) {
    switch (menu) {
      case 'AddCompany':
        this.router.navigate(['/user/company']);
        break;
      case 'CompanySetting':
        this.router.navigate(['/company/setting']);
        break;
      case  'Subscription':
        this.router.navigate(['/subscription']);
        break;
      case 'Warehouses':
        this.router.navigate(['/app/Setup/warehouse']);
        break;
      case 'Cities':
        this.router.navigate(['/app/Setup/city']);
        break;
      case 'Countries':
        this.router.navigate(['/app/Setup/country']);
        break;
      case  'Customers':
        this.router.navigate(['/app/Setup/customer']);
        break;
      case 'ChangePassword':
        this.router.navigate(['/user/change-password']);
        break;
      case 'UserProfile':
        this.router.navigate(['/userProfile/user-profile']);
        break;
      default:
        break;
    }
  }

  searchKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.search();
    } else if (event.key === 'Escape') {
      const input = document.querySelector('.mobile-view');
      if (input && input.classList) {
        input.classList.remove('mobile-view');
      }
      this.searchKey = '';
    }
  }

  searchAreaClick(event): void {
    event.stopPropagation();
  }
  searchClick(event): void {
    if (window.innerWidth < environment.menuHiddenBreakpoint) {
      let elem = event.target;
      if (!event.target.classList.contains('search')) {
        if (event.target.parentElement.classList.contains('search')) {
          elem = event.target.parentElement;
        } else if (
          event.target.parentElement.parentElement.classList.contains('search')
        ) {
          elem = event.target.parentElement.parentElement;
        }
      }

      if (elem.classList.contains('mobile-view')) {
        this.search();
        elem.classList.remove('mobile-view');
      } else {
        elem.classList.add('mobile-view');
      }
    } else {
      this.search();
    }
    event.stopPropagation();
  }

  search(): void {
    if (this.searchKey && this.searchKey.length > 1) {
      this.router.navigate([this.adminRoot + '/pages/miscellaneous/search'], {
        queryParams: { key: this.searchKey.toLowerCase().trim() },
      });
      this.searchKey = '';
    }
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event): void {
    const input = document.querySelector('.mobile-view');
    if (input && input.classList) {
      input.classList.remove('mobile-view');
    }
    this.searchKey = '';
  }
}
